import {$getSelection, $isRangeSelection, LexicalEditor, LexicalCommand} from 'lexical';
import {$patchStyleText} from '@lexical/selection';
import {FONT_SIZE, LINE_HEIGHT} from '../../constants';

export const shouldAddDots = (value: string, length: number = 5) => {
    return value?.length > length ? value.substring(0, length) + '...' : value;
};

export const createDispatchCommandWithoutPayload =
    (editor: LexicalEditor) => (command: LexicalCommand<void>) =>
        editor.dispatchCommand(command, null);

export const createDispatchCommand =
    (editor: LexicalEditor) =>
    <T>(command: LexicalCommand<T>, payload: T): void => {
        editor.dispatchCommand(command, payload);
    };

export const addPx = (value: number | string) => `${value}px`;

export const createUpdateFontSize = (editor: LexicalEditor) => (newFontSize: string) =>
    editor?.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            $patchStyleText(selection, {
                [FONT_SIZE]: addPx(newFontSize),
                [LINE_HEIGHT]: addPx(`${parseInt(newFontSize, 10) * 1.5}`)
            });
        }
    });

const isHtmlText = (htmlString: string): boolean => {
    const htmlTagPattern = /<([a-zA-Z]+)(\s[^>]*)?>.*?<\/\1>/s;
    const selfClosingTagPattern = /<([a-zA-Z]+)(\s[^>]*)?\/>/;

    return htmlTagPattern.test(htmlString) || selfClosingTagPattern.test(htmlString);
};

export const generatingHtmlString = (htmlString: string, isFromTextEditor: boolean) => {
    if (isFromTextEditor) {
        return htmlString;
    }

    return htmlString
        .replace(/^\n+|\n+$/g, '')
        .replace(/<</g, '&lt;&lt;')
        .replace(/>>/g, '&gt;&gt;')
        .split(/\r?\n/)
        .map(line => (isHtmlText(line) ? line : `<p>${line}</p>`))
        .join('');
};
